<template>
  <el-dialog title="订单退款" v-model="refundVisible" width="60%">
    <div v-if="refundList.length">
      <el-table :data="refundList">
        <el-table-column label="商品名称" prop="title" />
        <el-table-column label="待核销数量" prop="count" />
        <el-table-column label="已核销数量" prop="finishCount" />
        <el-table-column label="已退回数量" prop="rejectCount" />
        <el-table-column label="本次退回数量">
          <template #default="{ row }">
            <el-input-number
              v-model="row.verifyCount"
              :min="0"
              :max="
                row.count - row.finishCount > 0
                  ? row.count - row.finishCount
                  : 0
              "
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <el-form label-width="80px" class="mt-10">
        <el-form-item label="退款金额">
          <el-input-number
            v-model="refundAmount"
            :step="0.01"
            :min="0"
            :max="getRefundAmount()"
          ></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <el-button @click="refundVisible = false">取 消</el-button>
      <el-button :loading="refundLoading" type="primary" @click="refundOrder">
        确 定
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import {
  refundProductOrder,
} from '@/api/order'
import {
  checkRefundAmount,
} from '@/utils/tool'
export default {
  name: 'ProductRefund',
  emits: ['fetch-data'],
  data() {
    return {
      refundVisible: false,
      refundLoading: false,
      refundList: [],
      refundAmount:0,
      showForm:{}
    }
  },
  methods: {
    showRefund(productList,showForm) {
      this.refundList = productList
      this.refundAmount = 0
      this.showForm = showForm
      this.refundVisible = true
    },
    async refundOrder() {
      this.refundLoading = true
      const list = []
      this.refundList
        .filter((i) => !!i.verifyCount)
        .forEach((i) => {
          list.push({
            productId: i.productId,
            count: i.verifyCount,
          })
        })
      const result = await refundProductOrder({
        orderId: this.showForm.orderId,
        productList: list,
        refundAmount: this.refundAmount,
      })
      this.refundLoading = false
      if (!!result) {
        this.refundVisible = false
        this.dialogFormVisible = false
        this.$message.success('商品退款成功')
        this.$emit('fetch-data')
      }
    },
        // 获取能退的金额
    getRefundAmount() {
      return checkRefundAmount(this.showForm)
    },
  },
}
</script>

<style lang="scss" scoped>
.mt-10 {
  margin-top: 10px;
}
</style>
